import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-invest-finish-sign',
  templateUrl: './invest-finish-sign.component.html',
  styleUrls: ['./invest-finish-sign.component.scss'],
})
export class InvestFinishSignComponent implements OnInit {

  @Input() public movement;
  @Input() public signDocuments;
  @Input() public walletBalance: number = 0;
  @Input() public pendingPromos: any[] = [];
  @Output() public signedEvent = new EventEmitter<any>();
  @Output() public removeModalEvent = new EventEmitter<any>();
  @Output() public openMoneyInEvent = new EventEmitter<void>();

  step: number;
  text: string = this.translate.instant('SIGN.PENDING');
  image: number = 12;
  btnList = [
    {
      type: 'primaryDark',
      index: 1,
      title: this.translate.instant('SIGN.BTN'),
    }
  ];
  noFundsText: string = '';
  noFundsBtnList: { type: string; index: number; title: string }[] = [];

  constructor(private cdRef: ChangeDetectorRef, private translate: TranslateService, private utils: UtilsService) { }

  ngOnInit() {
    const promoMoney = Math.floor(this.pendingPromos.reduce((sum, p) => sum + (p.netAmount || 0), 0));
    const totalAvailable = this.walletBalance + promoMoney;
    this.noFundsText = this.translate.instant('INVEST.NO_FUNDS_TO_SIGN', {
      amount: this.movement.amount,
      available: totalAvailable,
      missing: this.movement.amount - totalAvailable
    });
    this.noFundsBtnList = [{ type: 'primaryDark', index: 1, title: this.translate.instant('INVEST.NO_FUNDS_TO_SIGN_BTN') }];
    if (totalAvailable < this.movement.amount) {
      this.step = 2;
    } else {
      this.step = !this.utils.checkEmptyField(this.signDocuments) && this.signDocuments.length > 0 ? -1 : 0;
    }
    this.cdRef.detectChanges();
  }

  continue() {
    this.step = 1;
    this.cdRef.detectChanges();
  }

  signed() {
    this.signedEvent.emit();
    this.cdRef.detectChanges();
  }

  removeModal() {
    this.removeModalEvent.emit();
    this.cdRef.detectChanges();
  }

  openMoneyIn() {
    this.openMoneyInEvent.emit();
    this.cdRef.detectChanges();
  }

}
